import React, { useEffect, useState } from "react";
import { WidgetProps } from "@rjsf/core";
import { IAuditNote } from "../../../../interfaces/IAuditNote";
import { AddAuditNoteAction } from "../../../note/AddAuditNoteAction";
import { NoteAccordion } from "../../../note/NoteAccordion";
import { EvaluationCheck } from "../../EvaluationCheck";
import "./_EvaluationCheckWidget.less"
import { Icon, Divider } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { useEditableNotes } from "../../../../data/notes/useEditableNotes";
import { makeAccordionTitleId } from "../../jsonSchemaFields/AccordionObjectField/AccordionItemObjectField";

export interface IEvalutaionCheckWidgetOptions {
    requiredCerts?: string[],
};

export type TEvaluationCehckValue = { status?: number[]; notes: IAuditNote[] }


export const EvalutaionCheckWidget: React.FC<WidgetProps> = (props) => {
    const {
        onChange,
        schema,
        options,
        fieldKey,
        formContext,
        id = ""
    } = props as any


    const t = useTranslation().t;
    const texts = {
        notes: t("Huomiot")
    };


    const [parentTitle, setParentTitle] = useState("");
    useEffect(() => {
        let getTitle = setTimeout(() => {
            const accordionId = id.substring(0, id.indexOf(`_${fieldKey}`))
            const accordionTitleId = makeAccordionTitleId(accordionId)
            const parentTitleEl = document.getElementById(accordionTitleId);
            setParentTitle((parentTitleEl?.innerHTML || "").trim());
        }, 400);
        return () => clearTimeout(getTitle);
    }, [id, fieldKey]);



    const enums: any[] = schema.enum ?? [0, 1, 2];

    const valueObj: TEvaluationCehckValue = typeof props.value === "object" && props.value?.notes ? props.value : { notes: [] }

    // Validate props
    if (enums.length > 3) console.warn("EvalutaionCheckWidget recieved more than 3 enums");
    if (!fieldKey) console.error("EvalutaionCheckWidget is missing key");

    // const { data: noteList, } = useNotesByField(fieldKey);

    const { noteList, updateNote, addNote, removeNote } = useEditableNotes(fieldKey);

    const text = options.title || schema.title || fieldKey;

    return (
        <div className="EvaluationCheckWidget-container">
            <EvaluationCheck
                enums={enums}
                onChange={(status) => onChange({ ...valueObj, status })}
                value={valueObj.status}
            />
            <Divider />
            <div className="EvaluationCheckWidget-notice-container">
                <div className="EvaluationCheckWidget-notice-title">
                    <Icon name="comment outline" />
                    {texts.notes}
                </div>

                <AddAuditNoteAction
                    fieldTitle={text}
                    fieldKey={fieldKey}
                    formType={formContext.formType}
                    parentObjectTitle={parentTitle}
                    observationFormReference={options.observationFormReference}

                    disabled={typeof props.value?.status === "undefined"}
                    onSubmitted={(note) => { }}
                />
            </div>

            <NoteAccordion
                fieldTitle={text}
                notes={noteList}
                onRemove={removeNote}
                onUpdate={updateNote}

                formType={formContext.formType}
                observationFormReference={options.observationFormReference}
            />
        </div>

    );
};
